import type { FulfilmentStatus } from "../core/api/use-get-fulfilment-detail/FulfilmentStatus";
import { fulfilmentSearchFiltersDefaultValues } from "./fulfilmentSearchFiltersDefaultValues";
import { store, type TaxManagerAppStoreSlice } from "./store";

export interface FulfilmentSearchFilters {
    deadlineFrom: Date;
    deadlineTo: Date;
    expired?: boolean;
    fulfilmentName?: string;
    statuses: FulfilmentStatus[];
    taxPayerWorkspaceId?: string;
    withWarnings: boolean;
}

const resetValues = () => {
    updateValues({
        ...fulfilmentSearchFiltersDefaultValues,
        deadlineFrom: store.state.fulfilmentSearchFilters.deadlineFrom,
        deadlineTo: store.state.fulfilmentSearchFilters.deadlineTo,
    });
};

const updateValues = (newValues: Partial<FulfilmentSearchFilters>) => {
    store.setState((state) => ({
        ...state,
        fulfilmentSearchFilters: {
            ...state.fulfilmentSearchFilters,
            ...newValues,
        },
    }));
};

export const fulfilmentSearchFiltersStoreSlice: TaxManagerAppStoreSlice<FulfilmentSearchFilters> =
    {
        resetValues: resetValues,
        updateValues: updateValues,
    };
